<section>
    <h1 class="mat-display-1">Sub-processors</h1>
  </section>
  <div class="content">
    <mat-accordion multi="true">
      <!-- cloudigo Infrastructure Subprocessors -->
      <div>
        <mat-expansion-panel [expanded]="true">
          <mat-expansion-panel-header>
            <h3 id="Infrastructure">cloudigo Infrastructure Sub-processors</h3>
          </mat-expansion-panel-header>
          <ng-template matExpansionPanelContent>
            <h4>
              <table class="tableBy4">
                <tr>
                    <td class="font-bold">Sub-processor</td>
                    <td class="font-bold">Purpose of processing</td>
                    <td class="font-bold">Location(s)</td>
                    <td class="font-bold">More Information</td>
                </tr>
                <tr>
                  <td>Amazon Web Services</td>
                  <td>Infrastructure (Cloud Service Provider)</td>
                  <td>Ireland</td>
                  <td>
                    <a href="https://aws.amazon.com/contact-us/compliance-support/" target="_blank">https://aws.amazon.com/contact-us/compliance-support/</a>
                  </td>
                </tr>
                <tr>
                  <td>Hetzner</td>
                  <td>Infrastructure (Cloud Service Provider)</td>
                  <td>Germany</td>
                  <td>
                    <a href="https://www.hetzner.com/legal/privacy-policy/" target="_blank">https://www.hetzner.com/legal/privacy-policy/</a>
                  </td>
                </tr>
                <tr>
                  <td>56Bit</td>
                  <td>Cloud system Administrator</td>
                  <td>Malta</td>
                  <td>
                    <a href="https://www.56bit.com/privacy-policy" target="_blank">https://www.56bit.com/privacy-policy/</a>
                  </td>
                </tr>
                <tr>
                  <td>Ibis group</td>
                  <td>System Administrator</td>
                  <td>Malta</td>
                  <td></td>
                </tr>
                <tr>
                  <td>MongoDB, Inc.</td>
                  <td>Infrastructure (Cloud Service Provider)</td>
                  <td>Ireland</td>
                  <td>
                    <a href="https://www.mongodb.com/legal/privacy" target="_blank">https://www.mongodb.com/legal/privacy</a>
                  </td>
                </tr>
                </table>
              </h4>
          </ng-template>
        </mat-expansion-panel>
      </div>

      <!-- cloudigo Platform Subprocessors -->
      <div>
        <mat-expansion-panel [expanded]="true">
          <mat-expansion-panel-header>
            <h3 id="Infrastructure">cloudigo Platform Sub-processors</h3>
          </mat-expansion-panel-header>
          <ng-template matExpansionPanelContent>
            <h4>
              <table class="tableBy4">
                <tr>
                    <td class="font-bold">Sub-processor</td>
                    <td class="font-bold">Purpose of processing</td>
                    <td class="font-bold">Location(s)</td>
                    <td class="font-bold">More Information</td>
                </tr>
                <tr>
                  <td>Epic</td>
                  <td>Verification codes, sms provider</td>
                  <td>Malta</td>
                  <td>
                    <a href="https://www.epic.com.mt/privacypolicy/" target="_blank">https://www.epic.com.mt/privacypolicy/</a>
                  </td>
                </tr>
                <tr>
                  <td>Twilio</td>
                  <td>Verification codes, sms provider</td>
                  <td>USA</td>
                  <td>
                    <a href="https://www.twilio.com/en-us/privacy" target="_blank">https://www.twilio.com/en-us/privacy</a>
                  </td>
                </tr>
                <tr>
                  <td>Stripe Technology Europe, Limited</td>
                  <td>Credit card payments</td>
                  <td>Ireland</td>
                  <td><a href="https://stripe.com/en-mt/legal/privacy-center" target="_blank">https://stripe.com/en-mt/legal/privacy-center</a></td>
                </tr>
                <tr>
                  <td>SALESmanago</td>
                  <td>Customer relationship management (CRM)</td>
                  <td>Poland</td>
                  <td>
                    <a href="https://www.salesmanago.com/info/information-obligation.htm" target="_blank">https://www.salesmanago.com/info/information-obligation.htm</a>
                  </td>
                </tr>
                <tr>
                  <td>Bitrix, Inc</td>
                  <td>Customer relationship management (CRM)</td>
                  <td>Germany </td>
                  <td>
                    <a href="https://www.bitrix24.eu/privacy/" target="_blank">https://www.bitrix24.eu/privacy/</a>
                  </td>
                </tr>
                <tr>
                  <td>Google Firebase, Google Analytics</td>
                  <td>Mobile app notifications, authentication, analytics</td>
                  <td>EU </td>
                  <td>
                    <a href="https://cloud.google.com/security/compliance/offerings#/regions=EMEA" target="_blank">https://cloud.google.com/security/compliance/offerings#/regions=EMEA</a>
                  </td>
                </tr>
                <tr>
                  <td>Zoho Corporation B.V. (The Netherlands)</td>
                  <td>Customer support, Customer relationship management (CRM)</td>
                  <td>EU</td>
                  <td>
                    <a href="https://www.zoho.com/privacy.html" target="_blank">https://www.zoho.com/privacy.html</a>
                  </td>
                </tr>
                <tr>
                  <td>Truevo Payments</td>
                  <td>Credit card payments</td>
                  <td>Malta</td>
                  <td>
                    <a href="https://truevo.com/privacy-policy/" target="_blank">https://truevo.com/privacy-policy/</a>
                  </td>
                </tr>
                </table>
              </h4>
          </ng-template>
        </mat-expansion-panel>
      </div>
    </mat-accordion>
  </div>